/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'outline/16/arrow-last': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g class="nc-icon-wrapper" _fill="none" _stroke="#272c33" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path pid="0" d="M.5 8.5h11M6.5 3.5l5 5-5 5"/><path pid="1" data-color="color-2" d="M15.5 1.5v14"/></g>'
  }
})
